import { TableCell, TableRow, IconButton } from '@mui/material'
import CircleCheckbox from 'src/Component/CircleCheckbox'
import eyeIcon from 'src/assets/icons/eyeIcon.png'
import deleteIcon from 'src/assets/icons/deleteIcon.png'

type DataRowProps = {
  id: number
  date: string
  title: string
  name: string
  commentsCount: number
  onViewDetailsClick: (id: number) => void
  onDeleteClick: (id: number) => void
  selected: boolean
  onSelect: (id: number) => void
}
const DataRow = ({
  id,
  date,
  title,
  name,
  commentsCount,
  selected,
  onViewDetailsClick,
  onDeleteClick,
  onSelect,
}: DataRowProps) => {
  return (
    <TableRow hover tabIndex={-1}>
      <TableCell padding='checkbox'>
        <CircleCheckbox checked={selected} onChange={(checked) => onSelect(id)} />
      </TableCell>
      <TableCell>{date}</TableCell>
      <TableCell>{title}</TableCell>
      <TableCell>{name}</TableCell>
      <TableCell>{commentsCount}</TableCell>
      <TableCell align='center'>
        <IconButton onClick={() => onViewDetailsClick(id)}>
          {' '}
          <img src={eyeIcon} alt='eyeIcon' />{' '}
        </IconButton>
        <IconButton onClick={() => onDeleteClick(id)}>
          {' '}
          <img src={deleteIcon} alt='deleteIcon' />{' '}
        </IconButton>
      </TableCell>
    </TableRow>
  )
}

export default DataRow
